import React, {useState, useEffect} from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import {connect} from "react-redux";
import './activityBaPingModal.less';
import {LmCarousel} from './lmCarousel';
import {axios_} from "../../../tools/axios_";
import {getAnalysisData} from "./acticityHelper";
import { jumpToLaunch } from './jumpActivityLaunch'
import { Utils } from '../../../tools/utils'


// 弹窗：活动霸屏
const ActivityBaPingModal = props => {
  const initData = () => {
    const str = sessionStorage.getItem('session_activity_list');
    return JSON.parse(str || '[]');
  };
  const initState = {
    activityRuleId:'',
    list:initData()
  };
  const [state, setState] = useState(initState);

  // setState方法
  const $set = (curState) => {
    if (typeof curState !== 'object') return;
    setState(preState => ({...preState, ...curState}))
  };
  useEffect(_=>{
    if (props.visible) {
      const list = initData();
      const activityRuleId = list.length>0 ? list[0].activityRuleId : '';
      $set({list,activityRuleId})
    }
  },[props.visible]);
  // 设为已读
  const doSee = activityRuleId => {
    axios_({
      url: `/api/admin/user/addExtends?key=ACTIVITY_COMPANY_PROMPT&value=${activityRuleId}`,
      method: 'get',
      headers: {
        'access-token': props.token,
        ...getAnalysisData()
      }
    }).then(res => {
      if (res.data.status === 200){
        redirect(activityRuleId);
        props.onOk();
      }
    }).finally(_=>{
        const {list,activityRuleId} = state;
        const hasAc = list.find(item => { return activityRuleId == item.activityRuleId });
        console.log('hasAc :>> ', hasAc);
        if (hasAc) {
            Utils.customTrack('MerchantHomeActivityPopupClick', {
                activity_rule_id:hasAc.activityRuleId,
                activity_rule_name:hasAc.ruleName
            });
        }
        
    })
  };
  // 跳转页面
  const redirect = (activityRuleId) => {
    const item = getItem(activityRuleId);
    jumpToLaunch(item, props)
  };
  const getItem = activityRuleId => {
    const _list = state.list.filter((item,pos) => item.activityRuleId === activityRuleId);
    return _list.length > 0 ? _list[0] : {};
  };
  // 获取activityRuleId
  const getId = index => {
    const _list = state.list.filter((item,pos) => pos === index);
    return _list.length > 0 ? _list[0].activityRuleId : "";
  };
  return (
    <Modal
        open={props.visible}
      onCancel={props.onCancel}
      wrapClassName='activity_baping_wrap_modal'
      className="activity_baping_modal_div"
      closable={false}
      maskClosable={false}
      width={600}
      footer={null}
    >
      <div className="content_div">
        <span
          className="icon_close_span"
          onClick={props.onCancel}
        >
          <CloseOutlined />
        </span>
        <div className="upper_div">
          <LmCarousel
            list={state.list}
            onClick={index => {
              doSee(getId(index));
            }}
            onChange={index=>{
              $set({activityRuleId:getId(index)});
            }}
          />
        </div>
        <div className="bottom_div">
          <Button onClick={_=>{
            doSee(state.activityRuleId);
          }}>立即查看</Button>
        </div>
      </div>
    </Modal>
  );
};
function mapStateToProps(state) {
  return { token: state.token };
}
export default connect(mapStateToProps)(ActivityBaPingModal);
